import PropTypes from 'prop-types';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { PKUrl, SidebarInfo, SidebarInfoColumn } from 'components/index';
import { number } from 'utils';

export const Policy = ({ contact = {} }) => {
	const { policy = {}, productName, client = {}, campaign = {} } = contact;
	const { policyNo, systemId, insurancePremium } = policy;
	const { ccdId } = client;
	const { communicationCode, endDate } = campaign;

	return (
		!isNilOrEmpty(policyNo) && (
			<SidebarSection heading={getLabelMessage('contactDetail:insuranceContract')}>
				<SidebarInfo>
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:policyNo')}
						value={
							<PKUrl.PKPolicy
								partnerId={ccdId}
								policyNo={policyNo}
								systemId={systemId}
								unlock
								campaignEndDate={endDate}
								communicationCode={communicationCode}
								muiLink
							>
								{policyNo}
							</PKUrl.PKPolicy>
						}
					/>

					<SidebarInfoColumn attribute={getLabelMessage('contactDetail:product')} value={productName} />
					<SidebarInfoColumn
						attribute={getLabelMessage('contactDetail:amount')}
						value={number(insurancePremium)}
					/>
				</SidebarInfo>
			</SidebarSection>
		)
	);
};

Policy.propTypes = {
	contact: PropTypes.object,
};

export default Policy;
